import { NoImage } from "@assets/constant/index.constant";
import { Switch } from "@components/ui/switch";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { isNullCheck } from "@utils/helper/index.helper";
import { useHandleAction } from "@utils/hook/index.hook";
import { useSelectionStore } from "@utils/states/index.state";
import { useMemo } from "react";
import { NavLink } from "react-router";

const ColumnList = ({
  refetch,
  moveToBin,
  moveToDraft,
}: {
  refetch?: () => void;
  moveToBin: (id: string | number, state: boolean) => void;
  moveToDraft: (id: string | number, state: boolean) => void;
}) => {
  const BlogEndpoint = useMemo(() => endpoint["blog"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction, searchParams, setSearchParams } = useHandleAction({
    endpoint: BlogEndpoint,
    refetch,
  });
  const category =
    searchParams.get("data-category")?.toLocaleLowerCase()?.split("-")[0] ===
    "all"
      ? ""
      : searchParams.get("data-category")?.toLocaleLowerCase()?.split("-")[0] ||
        "";
  console.log("category", category);
  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row.id}</span>
        ),
        sortable: true,
      },
      {
        name:
          category == "scheduled"
            ? "Scheduled Date"
            : category == "deleted"
            ? "Status"
            : "Publish Date",
        cell: (row: any) => (
          <>
            <span className="font-semibold text-gray-700">
              {row?.is_deleted
                ? "Deleted"
                : new Intl.DateTimeFormat("en-US", {
                    day: "2-digit",
                    year: "numeric",
                    month: "short",
                  }).format(new Date(row?.publish_date))}
            </span>
          </>
        ),
        sortable: true,
      },
      {
        name: "Feature Image",

        cell: (row: any) => {
          return (
            <ZoomImage>
              <img
                src={row.featured_image || NoImage}
                alt="featured"
                onError={(e: any) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src = NoImage;
                }}
                className="w-12 h-12 object-cover rounded"
              />
            </ZoomImage>
          );
        },
        sortable: false,
      },
      {
        name: "Title",
        cell: (row: any) => (
          <div className="flex items-center justify-start w-full h-full">
            {" "}
            <Tooltip description={row.title}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {row.title}
                </span>
              </div>
            </Tooltip>
          </div>
        ),
        sortable: true,
      },

      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            {category === "deleted" && (
              <button
                className="text-[#1DA077] cursor-pointer"
                onClick={() => {
                  moveToDraft(row.slug, false);
                }}
                title="Restore"
              >
                Restore
              </button>
            )}

            {category !== "deleted" && (
              <NavLink to={`/add-blogsC?page=edit&page-item=${row.slug}`}>
                <button
                  type="button"
                  className="text-[#1DA077] cursor-pointer"
                  // onClick={() => handleAction({ type: "page-edit", data: row.id })}
                  title="Edit"
                >
                  Edit
                </button>
              </NavLink>
            )}

            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                category !== "deleted"
                  ? moveToBin(row.slug, true)
                  : handleAction({
                      type: "confirm",
                      data: { type: "delete", id: row.slug },
                    });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );
  return columns;
};

const CategoryColumnList = ({
  refetch,
  toggleActiveStatus,
}: {
  refetch?: () => void;
  toggleActiveStatus: (id: string | number, state: boolean) => void;
}) => {
  const BlogEndpoint = useMemo(() => endpoint["blog"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction, searchParams, setSearchParams } = useHandleAction({
    endpoint: BlogEndpoint,
    refetch,
  });

  const columns = useMemo(
    () => [
      {
        name: "ID",

        cell: (row: any) => (
          <span className="font-semibold text-gray-700">{row.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Category Name",

        cell: (row: any) => {
          return (
            <div className="flex items-center justify-start w-full h-full gap-4">
              {" "}
              <ZoomImage>
                <img
                  src={row.media || NoImage}
                  alt="featured"
                  onError={(e: any) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = NoImage;
                  }}
                  className="w-12 h-12 object-cover rounded"
                />
              </ZoomImage>
              <Tooltip description={row.name}>
                <div className="flex justify-start text-gray-800">
                  <span className="text-start w-fit max-w-[150px] truncate">
                    {row.name}
                  </span>
                </div>
              </Tooltip>
            </div>
          );
        },
        sortable: false,
      },

      {
        name: "Actions",
        cell: (row: any) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <Tooltip description={"Toggle Visibility"}>
              <div>
                <Switch
                  checked={row?.is_show}
                  onCheckedChange={(value) =>
                    toggleActiveStatus(row?.id, value)
                  }
                />
              </div>
            </Tooltip>

            <button
              type="button"
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "modal-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>

            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() =>
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                })
              }
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );
  return columns;
};

export { ColumnList, CategoryColumnList };
